import { render, staticRenderFns } from "./InventoryOverviewVehicle.vue?vue&type=template&id=4e966f58&"
import script from "./InventoryOverviewVehicle.vue?vue&type=script&lang=js&"
export * from "./InventoryOverviewVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports